import React from 'react';
import clone from 'clone';
import classNames from 'classnames';

class ScrollTab extends React.Component {
  constructor(props) {
    super(props);
  }
  handleScrollClick(item) {
    const values = [];
    this.options.forEach((singleitem) => {
      if (singleitem.key === parseInt(item.key, 10)) {
        singleitem.isChecked = !singleitem.isChecked;
      }
      if (singleitem.isChecked) values.push(singleitem);
    });
    this.props.handleScrollBox(values);
  }
  render() {
    this.options = clone(this.props.options);
    this.options.map((item) => {
      if (this.props.value.indexOf(item.slug) !== -1) {
        item.isChecked = true;
        item.CustomIconClass = classNames({
          'brandlist-icon ion-android-checkmark-circle': true,
        });
      } else {
        item.isChecked = false;
        item.CustomIconClass = classNames({
          'brandlist-icon ion-ios-circle-outline': true,
        });
      }
    });
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    const height = { MaxHeight: '200px' };
    return (<div className="brandlist" style={height}>
      <div className={childInputClass}>
        <ul className="brandlist-group" style={{ listStyle: 'none' }}>
          {this.options.map((item, index) => {
            return <li key={'brand-' + index} id={item.slug} onClick={this.handleScrollClick.bind(this, item)}><a>{item.value}</a><i className={item.CustomIconClass}></i></li>;
          })
          }
        </ul>
      </div>
    </div>);
  }
}

ScrollTab.propTypes = {
  'type': React.PropTypes.string,
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'handleScrollBox': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
};

export default ScrollTab;



// WEBPACK FOOTER //
// ./assets/src/frontend/element/scrollbox.js